angular.module('unica_archive_media.archive_media_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// MEDIA
		.state('app.archive_media', {
			url: '/archive-media',
			abstract: true,
			views: {
				'mainContent': {
					templateUrl: './modules/archive-media/templates/archive-media.html',
					controller: 'ArchiveMediaBasicController'
				}
			},
			params: {
				need_auth: true
			}
		})

			// MEDIA LIST
			.state('app.archive_media.list', {
				url: '/list/:event_id/:directory_id',
				views: {
					'mediaContent': {
						templateUrl: './modules/archive-media/templates/list.html',
						controller: 'ArchiveMediaListController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Lista Archivio Media',
					parent: function($scope) {
						return 'app.archive_media_directory.list({ event_id:' + $scope.event_id + '})';
					}
				}
			});


});

